/* eslint-disable react/prop-types */
import { FC } from 'react';
import { Logo } from 'cosmos-components';
import { Divider } from 'src/components';
import styled, { css } from 'styled-components';
import { getScreenBreaks } from 'src/utils/htmlHelper';
import heroBanner from 'src/assets/images/hero-banner-new.jpg';
import { HeaderIconContainer, StyledHeroBanner } from './Header';
import { useWindowDimensions } from 'src/hooks/useWindowDimensions';
import { DeviceType } from 'src/enums';

export const EMHeader: FC = () => {
    const { deviceType } = useWindowDimensions();

    return (
        <StyledHeader>
            <HeaderIcons id="header-icons" deviceType={deviceType}>
                <HeaderIconContainer>
                    <MonteRVStyledLogo name="coloredElmonteSimple" deviceType={deviceType} />
                </HeaderIconContainer>
                <HeaderIconContainer>
                    <MightyStyledLogo name="coloredMighty" deviceType={deviceType} />
                </HeaderIconContainer>
            </HeaderIcons>
            <StyledHeroBanner src={heroBanner} />
            <StyledDivider />
        </StyledHeader>
    );
};

export const HeaderIcons = styled.div<{ deviceType: DeviceType }>`
    display: flex;
    padding: 0rem;
    margin: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '0 1rem' : '0 3rem 0.5rem'};
    min-height: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '5rem' : '8rem'};
    border-top: 0.1rem solid ${({ theme: { colors } }) => colors.secondaryGrey}; 
    justify-content: 'flex-start';
    align-items: center;
`;

export const StyledHeader = styled.div`
    display: inline-block;
    margin: 0;
    width: 100%;
    margin-bottom: 0;
`;
export const StyledDivider = styled(Divider)`
    background-image: ${({ theme: { colors } }) =>
        `linear-gradient(to left, ${colors.yellow},  ${colors.orange}, ${colors.red})`};
    height: 0.7rem;
    border-top: none;
    display: inline-block;
    padding-right: calc(100% - 0.5px);
    position: relative;
    top: -0.3rem;
    @media (min-width: ${(props) => getScreenBreaks(props).screenLMin}) {
        height: 1rem;
    }
`;

const coloredlogo = css`
    @media (min-width: ${(props) => getScreenBreaks(props).screenMDMin}) {
        padding-left: 0.1rem;
    }
`;

export const MonteRVStyledLogo = styled(Logo)<{ deviceType: DeviceType }>`
    ${coloredlogo};
    width: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '10.5rem' : '20rem'};
    padding-right: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '1.16rem' : '2.16rem'};
    vertical-align: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '-1.5rem' : '-1rem'};
`;

export const MightyStyledLogo = styled(Logo)<{ deviceType: DeviceType }>`
    ${coloredlogo};
    width: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '5.5rem' : '10rem'};
    vertical-align: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '-1.5rem' : '-3.5rem'}
`;
